import { render, staticRenderFns } from "./OpenSlotModal.vue?vue&type=template&id=8a207ffe&"
import script from "./OpenSlotModal.vue?vue&type=script&lang=js&"
export * from "./OpenSlotModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports